import { writable } from "svelte/store";
export const PICKED_DATE_RANGE_FOR_REPORT = writable({});
export const PICKED_EMPLOYEE_TO_REPORT = writable();
export const clearPickedEmployee = () => {
    PICKED_EMPLOYEE_TO_REPORT.set(null);
};
